import React from "react";

import "./GenericTable.css";
import ResizableDraggableTable from "../resizeableTable/ResizableDraggableTable";

function GenericTable({
  disableSort,
  sortState,
  updateSortKey,
  updateSortConfig,
  initialColumns,
  tabData,
  activeTab,
  setActiveTab,
  sideCardTabConfig,
  showMoreModal,
  setShowMoreModal,
  titleForSideCard,
  loading,
  disableHeader,
  onModalClose,
  currentPage,
  itemsPerPage,
  onPageChange,
  totalItems,
  enablePagination,
  onRowsPerPageChange,
  oppName,
  customComp,
  minWidthForDrawer,
  allowSelection=false,
  selectedRows=[], setSelectedRows=()=>{},
  loadingRows,
  toggleSelectAll = () => {
    if (selectedRows.length === tabData?.length) {
      setSelectedRows([]); // Deselect all
    } else {
      setSelectedRows(tabData); // Select all (entire row objects)
    }
  },
  isAllSelected = tabData?.length > 0 && selectedRows.length === tabData.length,
  isIndeterminate = selectedRows?.length > 0 && selectedRows.length < tabData.length
}) {
 


  

  return (
    <>
      <ResizableDraggableTable
        disableSort={disableSort}
        sortState={sortState}
        updateSortKey={updateSortKey}
        updateSortConfig={updateSortConfig}
        initialColumns={initialColumns}
        tabData={tabData}
        sideCardTabConfig={sideCardTabConfig}
        showMoreModal={showMoreModal}
        setShowMoreModal={setShowMoreModal}
        titleForSideCard={titleForSideCard}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        loading={loading}
        disableHeader={disableHeader}
        onModalClose={onModalClose}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        onPageChange={onPageChange}
        totalItems={totalItems}
        enablePagination={enablePagination}
        onRowsPerPageChange={onRowsPerPageChange}
        oppName={oppName}
        customComp={customComp}
        minWidthForDrawer={minWidthForDrawer}
        allowSelection={allowSelection}
        toggleSelectAll={toggleSelectAll}
          selectedRows={selectedRows}  setSelectedRows={setSelectedRows}
          isAllSelected={isAllSelected}
          isIndeterminate={isIndeterminate}
          loadingRows={loadingRows}
      />
    </>
  );
}

export default GenericTable;
